import { CURRENCIES } from './constants'

/**
 * Format price with currency symbol
 * Uses our custom CURRENCIES map to ensure all currencies display with symbols,
 * not codes (e.g., ₾ instead of GEL)
 */
export function formatPrice(price: number, currencyCode?: string): string {
  const code = currencyCode || 'USD'

  // Find currency in our CURRENCIES constant
  const currency = CURRENCIES.find(c => c.code === code)

  if (!currency) {
    // Fallback to Intl.NumberFormat if currency not in our list
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: code
    }).format(price)
  }

  // Format number with 2 decimal places
  const formattedNumber = price.toFixed(2)

  // For most currencies, symbol goes before the number
  // Exception: some currencies like Polish Złoty traditionally go after
  if (code === 'PLN') {
    return `${formattedNumber} ${currency.symbol}`
  }

  // Default: symbol before number
  return `${currency.symbol}${formattedNumber}`
}
